import { Markdown } from '@/components/ui/smoothdown';
import { cn } from '@/lib/utils';

import { labelIdOf } from '../../fieldIds';
import { ClampedText } from '../../internals/ClampedText';
import { MrkdwnText } from '../../internals/MrkdwnText';
import { useCardMetrics } from '../../internals/useCardMetrics';
import {
  HELD_CLASS,
  MARKDOWN_CLASS,
  TEXT_BOX_CLASS,
  TEXT_STYLE,
  type TextStyleName,
} from '../../tokens';

export const ReadOnlyValue = ({
  id,
  label,
  value,
  placeholder,
  format,
  lines,
  textStyle,
  held,
  toneClass,
  bodyClass,
}: {
  id: string;
  label: string | undefined;
  value: string;
  placeholder: string | undefined;
  format: 'plain' | 'markdown' | 'mrkdwn';
  lines: number | undefined;
  textStyle: TextStyleName;
  held: boolean;
  toneClass?: string;
  bodyClass?: string;
}) => {
  const metrics = useCardMetrics();
  const content = !value.trim() ? (
    <span className="text-foreground-muted">{placeholder}</span>
  ) : format === 'markdown' ? (
    <Markdown
      id={id}
      content={value}
      className={cn(
        MARKDOWN_CLASS,
        TEXT_STYLE[textStyle],
        bodyClass,
        toneClass
      )}
    />
  ) : format === 'mrkdwn' ? (
    <MrkdwnText text={value} />
  ) : (
    value
  );

  return (
    <div
      id={id}
      aria-labelledby={label ? labelIdOf(id) : undefined}
      className={cn(
        TEXT_BOX_CLASS,
        TEXT_STYLE[textStyle],
        bodyClass,
        toneClass,
        metrics.bodyMaxHeight,
        'min-h-[1lh] overflow-y-auto py-0',
        format === 'plain' && 'whitespace-pre-wrap',
        held && HELD_CLASS
      )}
    >
      <ClampedText lines={lines}>{content}</ClampedText>
    </div>
  );
};
